import { Routes, Route } from "react-router-dom";

import Login from "./pages/users/LoginPage";
import RecoverPasswordPage from "./pages/users/RecoverPasswordPage";
import ActivationAccountPage from "./pages/users/ActivationAccountPage";
import HomePage from "./pages/global/HomePage";
import UsersPage from "./pages/users/UsersPage";
import NotFound from "./pages/global/NotFoundPage";
import DocumentTestPage from "./pages/global/DocumentTestPage";
import VacuumBreakerSelectionPage from "./pages/noza/VacuumBreakerSelectionPage";
import DeaeratorsPage from "./pages/dearators/DeaeratorsPage";
import DeaeratorsPhcPage from "./pages/dearators_phc/DeaeratorsPhcPage";
import BudgetsPage from "./pages/budgets/BudgetsPage";
import BudgetsExcelPage from "./pages/budgets_excel/BudgetsExcelPage";
import MPMetalSheetTablePage from "./pages/tables/MPMetalTablePage";
import MPStainlessSteelSheetTablePage from "./pages/tables/MPStainlessSteelTempTablePage";
import MPStainlessSteelTablePage from "./pages/tables/MPStainlessSteelTablePage";
import MPSteelElevatedTempTablePage from "./pages/tables/MPSteelElevatedTempTablePage";
import MPTubeElevatedTempTablePage from "./pages/tables/MPTubeElevatedTempTablePage";
import MPTubeRoomTempTablePage from "./pages/tables/MPTubeRoomTempTablePage";
import MPTensileStrengthVsTempPage from "./pages/tables/MPTensileStrengthVsTempPage";
import WeldingPage from "./pages/tables/WeldingPage";
import GestraPriceTablePage from "./pages/tables/GestraPriceTablePage";
import PaintSchemeTablePage from "./pages/tables/PaintSchemeTablePage";
import SpiraxSarcoPriceTablePage from "./pages/tables/SpiraxSarcoPriceTablePage";
import SessionExpiredModal from "./components/global/SessionExpiredModal";
import PrivateRoute from "./routes/PrivateRoute";
import Layout from "./components/global/Layout";
import { LayoutProvider } from "./context/LayoutContext";

function AppRoutes() {

    return (
        <LayoutProvider>
            <SessionExpiredModal />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/recover-password" element={<RecoverPasswordPage />} />
                <Route path="/:id/activate-account" element={<ActivationAccountPage type="ACTIVATION_ACCOUNT" />} />
                <Route path="/:id/reset-password" element={<ActivationAccountPage type="RESET_PASSWORD" />} />
                <Route element={<PrivateRoute />}>
                    <Route element={<Layout />}>
                        <Route path="/homepage" element={<HomePage />} />
                        <Route path="/create-new-budget" element={<BudgetsPage />} />
                        <Route path="/users" element={<UsersPage />} />
                        <Route path="/deaerators" element={<DeaeratorsPage />} />
                        <Route path="/deaerators-phc" element={<DeaeratorsPhcPage />} />
                        <Route path="/budgets" element={<BudgetsExcelPage />} />
                        <Route path="/mp-metal-sheet-table" element={<MPMetalSheetTablePage />} />
                        <Route path="/mp-stain-steel-temp-table" element={<MPStainlessSteelSheetTablePage />} />
                        <Route path="/mp-stain-steel-table" element={<MPStainlessSteelTablePage />} />
                        <Route path="/mp-steel-elevated-temp-table" element={<MPSteelElevatedTempTablePage />} />
                        <Route path="/mp-tube-elevated-temp-table" element={<MPTubeElevatedTempTablePage />} />
                        <Route path="/mp-tube-room-temp-table" element={<MPTubeRoomTempTablePage />} />
                        <Route path="/mp-tensile-strength-temp-table" element={<MPTensileStrengthVsTempPage />} />
                        <Route path="/welding" element={<WeldingPage />} />
                        <Route path="/gestra-price-table" element={<GestraPriceTablePage />} />
                        <Route path="/paint-scheme-table" element={<PaintSchemeTablePage />} />
                        <Route path="/spirax-sarco-price-table" element={<SpiraxSarcoPriceTablePage />} />
                        <Route path="/document-test" element={<DocumentTestPage />} />
                        <Route path="/vacuum-breaker-select" element={<VacuumBreakerSelectionPage />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Route>
            </Routes>
        </LayoutProvider>
    );
}

export default AppRoutes;
